export default "__VITE_ASSET__CpMBNGOM__"